import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
// import cssVars from 'css-vars-ponyfill'
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import Toasted from "vue-toasted";
import "v-slim-dialog/dist/v-slim-dialog.css";
import SlimDialog from "v-slim-dialog";
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts'
import VueNativeSock from 'vue-native-websocket'
// Loading overlay css
import "vue-loading-overlay/dist/vue-loading.css";

import { library } from '@fortawesome/fontawesome-svg-core'
import { faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueSimpleAlert from "vue-simple-alert";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

library.add(faHandHoldingUsd)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Vue.use(VueNativeSock, 'ws://192.168.0.5:50151', {
//   reconnection: true,
//   reconnectionAttempts: 5,
//   reconnectionDelay: 3000,
//   protocol: 'echo-protocol'
// });

Vue.component('apexchart', VueApexCharts)

Vue.prototype.moment = moment

// todo
// cssVars()

Vue.use(BootstrapVue);
Vue.use(Toasted);
Vue.use(SlimDialog);
Vue.use(VueSimpleAlert);
Vue.use(VueSweetalert2);

new Vue({
  el: "#app",
  router,
  template: "<App/>",
  components: {
    App
  },
});
